// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { isDevelopment, sendXHR, failedRequest } from "src/lib/utils";


// Stateful components

export class Message extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            active: false,
            read: this.props.read,
            icon_svg: ''
        };

        this.toggleMessage = this.toggleMessage.bind(this);
    }


    //
    // Functions
    //

    componentDidMount() {
        var this_component = this;
        this_component.getIcon();
    }

    toggleMessage(e) {
        e.preventDefault();

        var this_component = this;
        var read = this.state.read;
        var active = this.state.active;

        if (active) {
            this_component.setState({
                active: false
            });
        } else {
            this_component.setState({
                active: true
            });
            if (!read) {
                this_component.markAsRead();
            }
        }
    }


    markAsRead() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        this_component.setState({
            read: true
        });

        var message_id = this_component.props.id;

        var gatekeeper_options = {
            "source": "setmessage,2," + message_id + ",read",
            "data": [],
            "success": function(response){
                
            }
        };
        helpers.setGatekeeperData(gatekeeper_options);

        this_component.props.updateSessionStorage(message_id, 'read', true);

        let new_message_count = portal_context['notification_count'] - 1;

        portal_context["helpers"].updateNotificationCount(new_message_count);
    }

    markAsUnread() { // Only used for testing if we need to 'undo' markAsRead
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        this_component.setState({
            read: false
        });

        var message_id = this_component.props.id;

        var gatekeeper_options = {
            "source": "setmessage,2," + message_id + ",unread",
            "data": [],
            "success": function(response){
                
            }
        };
        helpers.setGatekeeperData(gatekeeper_options);

        this_component.props.updateSessionStorage(message_id, 'read', false);
    }

    truncateMessage(message_str, char_limit) {
        var truncated_str = String(message_str).replace(/<\/[^>]+>/gm, ' ');
        truncated_str = truncated_str.replace(/<[^>]+>/gm, '');
        
        if (truncated_str.length > char_limit) {
            return truncated_str.substr(0, char_limit - 1) + '...';
        } else {
            return truncated_str;
        }
    }

    getIcon() {
        var this_component = this;
        var portal_context = this_component['context'];
        var default_icon = portal_context['configuration']['noticeboard']['default_icon'];
        var icon_svg = default_icon ? default_icon : '';
        if(isDevelopment()) {
            this_component.setState({
                icon_svg: icon_svg
            });
        } else {
            var icon_id = this_component.props.icon;
            if (icon_id) {
                icon_id = String(icon_id);
                
                if (icon_id.length > 0) {
                    var endpoints_container = document.querySelector('#endpoints');
                    var url = endpoints_container.getAttribute('data-geticon') + '?id=' + icon_id;
                    
                    var xhr_parameters = {
                        'request_url': url,
                        'request_success': function(response) {
                            if (response.length > 0) {
                                icon_svg = response;
                                this_component.setState({
                                    icon_svg: icon_svg
                                });
                            }
                        },
                        'request_failure': failedRequest,
                        'request_extras': ""
                    };
            
                    sendXHR(xhr_parameters, 'GET');
                } else {
                    this_component.setState({
                        icon_svg: icon_svg
                    });
                }
            } else {
                this_component.setState({
                    icon_svg: icon_svg
                });
            }

        }
        
    }
    


    //
    // Render
    //


    render() {
        var this_component = this;
        var portal_context = this_component['context'];

        var message_id = this.props.id;
        var isActive = this.state.active;
        var read = this.state.read;

        var message_class = 'message';
        if (isActive) {
            message_class += ' message--active';
        }
        if (!read) {
            message_class += ' message--new';
        }

        var description = this_component.truncateMessage(this.props.message, 100);
        
        var default_action = portal_context['configuration']['noticeboard']['message_action'];
        default_action = default_action ? default_action : 'View more';
        var action = this.props.action.trim();
        var action_link = action.length > 0 ? action : default_action;
        
        var icon = this_component.state['icon_svg'];

        if (icon) {
            return (
                <div className={message_class} id={"mg-" + message_id}>
                    <button
                        className="message__header"
                        aria-expanded={isActive ? true : false}
                        aria-controls={"mg-" + message_id + "__content"}
                        onClick={this_component.toggleMessage}
                    >
                        <div className="message__icons">
                            <div className="message__icon" dangerouslySetInnerHTML={{__html: icon}}>
                            </div>
                            <div className="message__indicators">
                                <span className="message__indicator--new"></span>
                            </div>
                        </div>
                        <div className="message__content">
                            <div className="message__text">
                                <div className="message__info">
                                    <span className="message__date">{this.props.date}</span>
                                    <span className="message__category">{this.props.sender}</span>
                                </div>
                                <span className="message__title">{this.props.title}</span>
                                <span className="message__description"  dangerouslySetInnerHTML={{__html: description}}></span>
                            </div>
                            <span className="message__action-link">{action_link}</span>
                            <div className="message__minimise">Minimise<span className="message__minimise-btn"></span></div>
                        </div>
                    </button>
                    <div className={"message__panel" + (isActive ? '' : ' collapsed')} id={"mg-" + message_id + "__content"}>
                        <div className="message__body" dangerouslySetInnerHTML={{__html: this.props.message}} />
                    </div>
                </div>
            );
        }

        return null;
    }

};

Message.contextType = PortalContext;
